import { render, staticRenderFns } from "./BroadcastScreenLayout.vue?vue&type=template&id=6c887bba&scoped=true&"
import script from "./BroadcastScreenLayout.vue?vue&type=script&lang=js&"
export * from "./BroadcastScreenLayout.vue?vue&type=script&lang=js&"
import style0 from "./BroadcastScreenLayout.vue?vue&type=style&index=0&id=6c887bba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c887bba",
  null
  
)

export default component.exports